const styles = {
    marker: {
        popup: {
            img: {
                marginTop: '15px',
                width: '100%',
                minWidth: '250px'
            }
        }
    },
    geojson: {
        color: '#4980C0',
        weight: 5,
        opacity: 0.75
    },
    gpx: {
        color: '#38b274',
        weight: 5,
        opacity: 0.75
    },
    kml: {
        color: '#F29313',
        weight: 5,
        opacity: 0.75
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/openexplore/Mapbox/Mapbox.css.js